import React from 'react';

const FaviconRound: React.FC = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_ii_378_1257)">
        <rect width="24" height="24" rx="12" fill="#17E3B4" />
      </g>
      <rect
        x="0.75"
        y="0.75"
        width="22.5"
        height="22.5"
        rx="11.25"
        stroke="#020511"
        strokeOpacity="0.1"
        strokeWidth="1.5"
      />
      <rect
        x="6"
        y="13.39"
        width="11.3428"
        height="1.65992"
        rx="0.82996"
        fill="white"
      />
      <rect
        x="6"
        y="10.07"
        width="6.91633"
        height="1.65992"
        rx="0.82996"
        fill="white"
      />
      <rect
        x="8.49023"
        y="16.7094"
        width="3.59649"
        height="1.65992"
        rx="0.82996"
        fill="white"
      />
      <rect
        x="6"
        y="6.75"
        width="11.3428"
        height="1.65992"
        rx="0.82996"
        fill="white"
      />
      <rect
        x="14.5752"
        y="10.07"
        width="2.76653"
        height="1.65992"
        rx="0.82996"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_ii_378_1257"
          x="-2.66667"
          y="-2.66667"
          width="26.6667"
          height="29.3333"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.66667" />
          <feGaussianBlur stdDeviation="1.33333" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_378_1257"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-2.66667" dy="-2.66667" />
          <feGaussianBlur stdDeviation="1.33333" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_innerShadow_378_1257"
            result="effect2_innerShadow_378_1257"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default FaviconRound;
